import RecordRTC from "recordrtc";
import { VideoCallRoom } from "@/api/videoCall";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
let getRTCStatsTimer;
let pendingIceCandidates = [];
const state = {
  videoCallRoomId: "",
  agentRTC: null, // RTC 本體
  recorder: null, // 錄影
  chunks: [], // 錄影檔
  videoReady: false, // 是否正在進行 Video call
  videoDisplay: false, // 是否正在顯示鏡頭
  screenShareOn: false, // 是否正在分享螢幕
  remoteStream: null, // 遠端視訊串流
  localStream: null, // 本地視訊串流
  tracks: {
    localAudioTrack: null,
    localVideoTrack: null,
    remoteAudioTrack: null,
    remoteVideoTrack: null,
  },
  screenShareStream: null, // 螢幕分享串流
  videoSender: null, // 分享中的視訊
  audioSender: null, // 分享中的音訊
  videoOptions: {
    // 分享視訊鏡頭參數
    audio: false,
    video: false,
  },
  screenShareOptions: {
    video: { cursor: "never", enabled: true }, // 視訊資訊的設定
    audio: true, // 是否包含音訊資訊
    logicalSurface: false, // 設定是否包含所選螢幕外區域的一些資訊
  },
  fps: {
    in: 0,
    out: 0,
  },
  // 通話計時
  callStartedAt: null, // 以毫秒為單位的開始時間戳
  callDurationMs: 0, // 累積通話時間（毫秒）
  callTimer: null, // setInterval 的 ID
  callAccumulatedMs: 0, // 斷線前的累積通話時間（毫秒）
};

const actions = {
  setMessageId({ commit }, payload) {
    commit("setMessageId", payload);
  },
  toggleDisplay({ commit }, payload) {
    commit("toggleDisplay", payload);
  },
  async toggleShareScreen({ state, commit, dispatch }, payload) {
    if (payload) {
      // 開啟

      let options = state.screenShareOptions;
      try {
        let stream = await navigator.mediaDevices.getDisplayMedia(options);
        let videoTrack = stream.getVideoTracks()[0];

        state.videoSender.replaceTrack(videoTrack);

        // 偵聽關閉事件
        videoTrack.addEventListener("ended", () => {
          dispatch("shareWebcam");
          commit("toggleScreenShare", false);
        });

        commit("setScreenShareStream", stream);
        commit("toggleScreenShare", true);
        dispatch("handlelocalVideo", { stream, options });
      } catch (err) {
        console.error("Error: " + err);
      }
    } else {
      // 關閉串流 切換為 webcam
      state.screenShareStream.getTracks().forEach((track) => track.stop());
      dispatch("shareWebcam");
      commit("toggleScreenShare", false);
    }
  },
  shareWebcam({ state, dispatch }) {
    var stream = state.localStream;
    var videoTrack = stream.getVideoTracks()[0];
    state.videoSender.replaceTrack(videoTrack);

    dispatch("handlelocalVideo", { stream, options: state.videoOptions });
  },
  async initLocalStream({ commit, dispatch }, videoCallRoomId) {
    const initialOptions = {
      audio: true, //聲音開關
      video: {
        enabled: true,
        width: 640,
        height: 360,
        aspectRatio: 16 / 9,
        frameRate: { ideal: 30, max: 60 }, //偵率
        facingMode: "user",
      },
    };
    commit("setvideoCallRoomId", videoCallRoomId);
    commit("setVideoOptions", initialOptions);
    console.log("1. Init local stream.");
    let stream = null;
    try {
      stream = await navigator.mediaDevices.getUserMedia(initialOptions);

      commit("setLocalStream", stream);
      dispatch("handlelocalVideo", { stream, options: initialOptions });
      dispatch("initRTCPeerConnection", videoCallRoomId);
      return "success";
    } catch (error) {
      throw `catch: [${error.code}] ${error.name} - ${error.message}`;
    }
  },
  async initRTCPeerConnection({ commit, dispatch }, videoCallRoomId) {
    console.log("2. initRTCPeerConnection!");
    const stream = state.localStream;
    const AgentRTC = new RTCPeerConnection({
      // 配置ICE服務器
      iceServers: [
        {
          urls: "stun:stun.relay.metered.ca:80",
        },
        {
          urls: "turn:standard.relay.metered.ca:80",
          username: "d5f97d3c4f641166e47eee3f",
          credential: "1UsurL3wTWyHut3C",
        },
        {
          urls: "turn:standard.relay.metered.ca:80?transport=tcp",
          username: "d5f97d3c4f641166e47eee3f",
          credential: "1UsurL3wTWyHut3C",
        },
        {
          urls: "turn:standard.relay.metered.ca:443",
          username: "d5f97d3c4f641166e47eee3f",
          credential: "1UsurL3wTWyHut3C",
        },
        {
          urls: "turns:standard.relay.metered.ca:443?transport=tcp",
          username: "d5f97d3c4f641166e47eee3f",
          credential: "1UsurL3wTWyHut3C",
        },
        // {
        //   urls: "turn:172.22.192.181:443?transport=tcp",
        //   username: "asusturn",
        //   credential: "asusturnICEPassword",
        // },
        // { urls: "stun:stun.stunprotocol.org:3478" },
        // { urls: "stun:stun.l.google.com:19302" },
        // {
        //   urls: "turn:openrelay.metered.ca:443?transport=tcp",
        //   username: "openrelayproject",
        //   credential: "openrelayproject",
        // },
      ],
    });
    stream.getTracks().forEach((track) => {
      // console.log(`[A]Agent add local "${track.kind}" track.`);
      let sender = AgentRTC.addTrack(track, stream);
      commit("setSender", {
        kind: track.kind,
        sender: sender,
      });
    });

    // 建立 Offer 並送出
    const offer = await AgentRTC.createOffer();
    const offerSignal = JSON.stringify({ sdp: offer });
    console.log("3. create / setLocalDesc and send signal.");
    await AgentRTC.setLocalDescription(offer);
    dispatch(
      "videoCall/sendSignalToCustomer",
      { signal: offerSignal, videoCallRoomId },
      { root: true },
    );

    // 創建應答連接
    AgentRTC.onicecandidate = (e) => {
      // console.log('onicecandidate',e);
      if (e.candidate) {
        const signal = JSON.stringify({ candidate: e.candidate });
        dispatch(
          "videoCall/sendSignalToCustomer",
          { signal, videoCallRoomId },
          { root: true },
        );
      } else {
        // Null candidate means we are done collecting candidates.
        dispatch(
          "videoCall/sendSignalToCustomer",
          { signal: null, videoCallRoomId },
          { root: true },
        );
        console.log("5. onicecandidate & sendSignalToAgent.");
        console.log("6. done collecting candidates.");
      }
    };

    // 監聽 ICE 連接狀態
    // 錄影生命週期策略：
    // - connected: 若已有 remoteStream 且尚未錄影 → 開始錄影；同時啟動通話計時。
    // - disconnected/failed: 暫停通話計時並停止錄影，上傳未滿 30s 的最後片段；不合併。
    // - closed: 與 disconnected 類似，確保停止錄影並保留最後片段；不合併。
    AgentRTC.oniceconnectionstatechange = (e) => {
      let { iceConnectionState } = e.target;
      console.log("[status] => ", iceConnectionState);
      if (iceConnectionState == "connected") {
        // 標記開始時間並啟動計時器
        dispatch("markCallStarted");
        // 重連後若已有 remoteStream 且尚未錄影，啟動錄影
        if (!state.recorder && state.remoteStream) {
          dispatch("startRecording");
        }
      } else if (iceConnectionState == "disconnected") {
        // 斷線暫停計時（不歸零，待恢復後續續）
        dispatch("pauseCallTimer");
        // 暫停錄影並上傳最後片段（不合併）
        if (state.recorder) {
          dispatch("stopRecording");
        }
      } else if (iceConnectionState == "failed") {
        // 失敗視為斷線處理
        dispatch("pauseCallTimer");
        if (state.recorder) {
          dispatch("stopRecording");
        }
      } else if (iceConnectionState == "closed") {
        // 連線已關閉，確保錄影與計時都停下（合併留待 hangup 統一處理）
        dispatch("pauseCallTimer");
        if (state.recorder) {
          dispatch("stopRecording");
        }
      }
    };

    // 接收遠端 stream（可能多次觸發：audio/video/重協商）
    AgentRTC.ontrack = (e) => {
      // console.log(`[A]Agent add remote "${e.track.kind}" track from client`);
      // 綁定 remote Stream 到視訊元素
      let remoteVideo = document.querySelector(
        "#video-call-window #remoteVideo",
      );
      if (!remoteVideo) {
        console.warn(
          "remoteVideo element not found, skip binding remote stream.",
        );
        return;
      }
      if (remoteVideo.srcObject !== e.streams[0]) {
        remoteVideo.srcObject = e.streams[0];
      }
      remoteVideo.onloadedmetadata = function (e) {
        remoteVideo.play();
      };
      if (!state.remoteStream) {
        commit("setRemoteStream", e.streams[0]);
      } else {
        let stream = state.remoteStream;
        stream.addTrack(e.track);
        commit("setRemoteStream", stream);
      }
      // 首次收到遠端串流，若尚未開始錄影則啟動（避免黑畫面）
      if (!state.recorder) {
        dispatch("startRecording");
      }
    };

    getRTCStatsTimer = setInterval(() => {
      //  console.log('getRTCStatsTimer',getRTCStatsTimer);
      AgentRTC.getStats(null).then((stats) => {
        let inboundRtp = 0;
        let outboundRtp = 0;
        // inbound-rtp outbound-rtp
        stats.forEach((report) => {
          if (report.framesPerSecond == undefined) {
            return;
          }
          if (report.type == "inbound-rtp") {
            // inboundRtp = `inbound-rtp FPS: ${report.framesPerSecond}`;
            // console.log(inboundRtp);
            inboundRtp = report.framesPerSecond;
          } else if (report.type == "outbound-rtp") {
            // outboundRtp = `outbound-rtp FPS: ${report.framesPerSecond}`;
            // console.log(outboundRtp);
            outboundRtp = report.framesPerSecond;
          }
        });
        commit("setFPS", {
          in: inboundRtp,
          out: outboundRtp,
        });
      });
    }, 3000);

    commit("setAgentRTC", AgentRTC);
  },
  async receiveSignal({ dispatch, state }, payload) {
    // console.log("receiveSignal", payload);
    // receiveSignal 內的 setDescription 非同步問題
    // 導致 PC(後) <--> Mobile(先) 有異常
    // 調整後目前正常
    const AgentRTC = state.agentRTC;
    if (!AgentRTC) {
      console.log("AgentRTC Not Ready.");
      return;
    }
    if (payload.signal) {
      const videoCallRoomId = payload.videoCallRoomId;
      const signal = JSON.parse(payload.signal);

      if (signal.sdp) {
        console.log("[Recevie SDP]setRemoteDescription");
        await AgentRTC.setRemoteDescription(signal.sdp);
        if (pendingIceCandidates.length) {
          for (const candidate of pendingIceCandidates) {
            try {
              await AgentRTC.addIceCandidate(candidate);
            } catch (err) {
              console.warn("addIceCandidate (queued) failed", err);
            }
          }
          pendingIceCandidates = [];
        }
        const type = AgentRTC.remoteDescription.type;
        if (type == "offer") {
          AgentRTC.createAnswer().then(async (answer) => {
            await AgentRTC.setLocalDescription(answer);
            console.log("Recevie [Offer]");
            dispatch(
              "videoCall/sendSignalToCustomer",
              {
                videoCallRoomId,
                signal: JSON.stringify({ sdp: answer }),
              },
              { root: true },
            );
          });
        } else if (type == "answer") {
          console.log("Recevie [Answer]");
        }
      } else if (signal.candidate) {
        if (AgentRTC.remoteDescription) {
          await AgentRTC.addIceCandidate(signal.candidate);
        } else {
          pendingIceCandidates.push(signal.candidate);
        }
      }
    } else {
      console.log("Client collect ICE done");
      if (AgentRTC.remoteDescription) {
        await AgentRTC.addIceCandidate(null);
      }
    }
  },
  // 僅結束視訊
  async hangup({ state, commit, dispatch }) {
    // console.log("hangup");
    if (state.videoReady) {
      // 停止計時器並保留最後通話時長
      dispatch("stopCallTimer");
      state.agentRTC.close();
      state.localStream.getTracks().forEach((track) => {
        track.stop();
      });
      commit("cleanAgentRTC");
    }
    if (state.recorder) {
      await dispatch("stopRecording");
    }
    // 視訊結束後統一執行合併
    dispatch("mergeVideoFiles");
    // 重置通話時長
    commit("setCallDurationMs", 0);
    commit("setCallAccumulatedMs", 0);
  },
  handlelocalVideo({ commit }, { stream, options }) {
    // 控制本地Video player (正式上線不會顯示在畫面上)
    // console.log("handlelocalVideo:", stream, options);
    let localVideo = document.querySelector(
      "#video-call-window #videoCall-localVideo",
    );
    if (!localVideo) {
      console.warn("localVideo element not found, skip binding local stream.");
      return;
    }
    if (localVideo.srcObject !== stream) {
      localVideo.srcObject = stream;
      let videoTrack = localVideo.srcObject.getVideoTracks()[0];
      let audioTrack = localVideo.srcObject.getAudioTracks()[0];
      videoTrack ? (videoTrack.enabled = options.video.enabled) : "";
      audioTrack ? (audioTrack.enabled = options.audio) : "";
    }
    localVideo.onloadedmetadata = function (e) {
      console.log("4. LocalStream play.");
      localVideo.play();
      commit("toggleDisplay", true); // 開啟 video call 視窗
    };
  },
  // 開始錄影：使用合成後的最終 stream（混音遠端/本地音訊 + 遠端影像）
  // 以 timeSlice 分段上傳；合併僅在 hangup 統一進行。
  startRecording({ state, commit, dispatch, getters }) {
    const env = process.env.NODE_ENV;
    let recorder = state.recorder;
    let stream = getters.destStream;
    // let remoteVideo = document.querySelector("#remoteVideo");
    const options = {
      type: "video",
      // video: { width: 360, height: 640 },
      mimeType: "video/webm;codecs=vp8,vp9",
      timeSlice: 30000, // 30s 切一支錄影檔
      disableLogs: true, // 開發者工具不顯示log
      videoBitsPerSecond: 512000, // default 128000 (低畫質)
      frameInterval: 90,
      // 每個片段（預設 30s）產生時上傳；若中途 stopRecording()，會立即產生一個尾段。
      ondataavailable: async function (blob) {
        // 補充：1MB = size:1,000,000位元組
        if (env == "development") {
          console.log(
            "取得錄影資料",
            `Tracks:[${stream.getTracks().length}] `,
            blob,
          );
        }
        // production mode 才上傳到 server（不在這裡做合併）
        if (env == "production") {
          let formData = new FormData();
          formData.append("VideoFiles", blob);
          formData.append("VideoCallRoomId", state.videoCallRoomId);
          await VideoCallRoom.UploadRecoredFiles(formData)
            .then((res) => {
              if (res.status == 200) {
                console.log(`File uploaded Success. Size:${res.data[0].size}`);
              }
            })
            .catch((err) => {
              console.log("catch", err);
            });
        }
      },
    };

    if (!recorder) {
      // console.log("startRecording.startRecording.");
      recorder = RecordRTC(stream, options);
      recorder.startRecording();
      commit("setRecorder", recorder);
    }
  },
  // 停止錄影：回傳 Promise 以供外層 await；
  // dev 下載檔案、prod 最後片段上傳，然後清空 recorder。
  stopRecording({ state, commit }) {
    const env = process.env.NODE_ENV;
    const recorder = state.recorder;
    if (!recorder) return Promise.resolve();
    return new Promise((resolve) => {
      recorder.stopRecording(async function () {
        if (env == "development") {
          console.log("stopRecording.");
          // 本地開發環境執行下載測試(不上傳到server)
          let blob = recorder.getBlob();
          let url = URL.createObjectURL(blob);
          let downloadLink = document.createElement("a");
          downloadLink.target = "_blank";
          downloadLink.rel = "noreferrer noopener";
          downloadLink.style.display = "none";
          downloadLink.download = "record test.webm";
          downloadLink.href = url;
          downloadLink.click();
        } else if (env == "production") {
          try {
            let blob = recorder.getBlob();
            let formData = new FormData();
            formData.append("VideoFiles", blob);
            formData.append("VideoCallRoomId", state.videoCallRoomId);
            const res = await VideoCallRoom.UploadRecoredFiles(formData);
            if (res.status == 200) {
              console.log(`Final chunk uploaded. Size:${res.data[0].size}`);
            }
          } catch (err) {
            console.log("catch", err);
          }
        }
        commit("setRecorder", null); //clear recorder
        resolve();
      });
    });
  },
  async mergeVideoFiles({ state }) {
    const params = { videoCallRoomId: state.videoCallRoomId };
    await VideoCallRoom.MergeVideoFiles(params)
      .then(() => {
        console.log("Files merged Success.");
      })
      .catch((err) => {
        console.log("catch", err);
      });
  },
  // 標記開始時間與啟動計時
  markCallStarted({ state, commit }) {
    if (state.callTimer) return; // 已在計時中
    const start = Date.now();
    commit("setCallStartedAt", start);
    const id = setInterval(() => {
      const elapsed = Date.now() - state.callStartedAt;
      // 即時通話時長 = 累積 + 當前片段
      commit("setCallDurationMs", state.callAccumulatedMs + elapsed);
    }, 1000);
    commit("setCallTimer", id);
  },
  // 斷線暫停計時並保留累積
  pauseCallTimer({ state, commit }) {
    if (!state.callStartedAt) return; // 未開始或已暫停
    const segment = Date.now() - state.callStartedAt;
    commit("setCallAccumulatedMs", state.callAccumulatedMs + segment);
    if (state.callTimer) {
      clearInterval(state.callTimer);
      commit("setCallTimer", null);
    }
    commit("setCallStartedAt", null);
    // 更新為目前累積總時長
    commit("setCallDurationMs", state.callAccumulatedMs);
  },
  // 停止計時並寫入最後時長
  stopCallTimer({ state, commit }) {
    // 若仍在計時，先納入最後片段
    if (state.callStartedAt) {
      const segment = Date.now() - state.callStartedAt;
      commit("setCallAccumulatedMs", state.callAccumulatedMs + segment);
    }
    if (state.callTimer) {
      clearInterval(state.callTimer);
      commit("setCallTimer", null);
    }
    commit("setCallStartedAt", null);
    // 最終時長 = 累積
    commit("setCallDurationMs", state.callAccumulatedMs);
  },
};

const mutations = {
  setvideoCallRoomId(state, payload) {
    state.videoCallRoomId = payload;
  },
  setVideoOptions(state, payload) {
    state.videoOptions = payload;
  },
  toggleDisplay(state, payload) {
    state.videoDisplay = payload;
  },
  toggleAudio(state, payload) {
    state.videoOptions.audio = payload;
    state.localStream.getAudioTracks()[0].enabled = payload;
  },
  toggleVideo(state, payload) {
    state.videoOptions.video.enabled = payload;
    state.localStream.getVideoTracks()[0].enabled = payload;
  },
  toggleScreenShare(state, payload) {
    state.screenShareOn = payload;
  },
  setAgentRTC(state, payload) {
    state.agentRTC = payload;
    state.videoReady = true;
    state.videoDisplay = true;
  },
  setRemoteStream(state, stream) {
    state.remoteStream = stream;
    state.tracks.remoteAudioTrack = stream.getAudioTracks()[0];
    state.tracks.remoteVideoTrack = stream.getVideoTracks()[0];
  },
  setLocalStream(state, stream) {
    state.localStream = stream;
    state.tracks.localAudioTrack = stream.getAudioTracks()[0];
    state.tracks.localVideoTrack = stream.getVideoTracks()[0];
  },
  setScreenShareStream(state, payload) {
    state.screenShareStream = payload;
  },
  setSender(state, payload) {
    let { kind, sender } = payload;
    if (kind == "video") {
      state.videoSender = sender;
    } else if (kind == "audio") {
      state.audioSender = sender;
    }
  },
  setRecorder(state, payload) {
    state.recorder = payload;
  },
  setChunk(state, payload) {
    state.chunks.push(payload);
  },
  setFPS(state, payload) {
    state.fps = payload;
  },
  cleanAgentRTC(state) {
    clearInterval(getRTCStatsTimer);
    pendingIceCandidates = [];
    state.agentRTC = null;
    state.remoteStream = null;
    state.localStream = null;
    state.videoSender = null;
    state.audioSender = null;
    state.screenShareStream = null;
    state.tracks = {
      localAudioTrack: null,
      localVideoTrack: null,
      remoteAudioTrack: null,
      remoteVideoTrack: null,
    };
    state.videoReady = false;
    state.videoDisplay = false;
    state.fps = {
      in: 0,
      out: 0,
    };
    // 清理計時器（不重置 callDurationMs，以便後續使用）
    if (state.callTimer) {
      clearInterval(state.callTimer);
    }
    state.callTimer = null;
    state.callStartedAt = null;
    // 保留累積時長供後續使用（不歸零）
  },
  // 通話計時相關 mutations
  setCallStartedAt(state, payload) {
    state.callStartedAt = payload;
  },
  setCallDurationMs(state, payload) {
    state.callDurationMs = payload;
  },
  setCallTimer(state, payload) {
    state.callTimer = payload;
  },
  setCallAccumulatedMs(state, payload) {
    state.callAccumulatedMs = payload;
  },
};

const getters = {
  destStream(state) {
    // 最終欲錄製的 stream
    const ac = new AudioContext();
    const rs = state.remoteStream;
    const ls = state.localStream;
    const remoteAudioTrack = rs ? rs.getAudioTracks()[0] : null;
    const remoteVideoTrack = rs ? rs.getVideoTracks()[0] : null;
    const localAudioTrack = ls ? ls.getAudioTracks()[0] : null;

    const remoteAudioStream = new MediaStream();
    const localAudioStream = new MediaStream();

    if (remoteAudioTrack) remoteAudioStream.addTrack(remoteAudioTrack);
    if (localAudioTrack) localAudioStream.addTrack(localAudioTrack);

    // remoteAudioStream 與 localAudioStream 一定要有 audio track，否則這裡會報錯！
    let audioIn_01, audioIn_02;
    if (remoteAudioStream.getAudioTracks().length) {
      audioIn_01 = ac.createMediaStreamSource(remoteAudioStream);
    }
    if (localAudioStream.getAudioTracks().length) {
      audioIn_02 = ac.createMediaStreamSource(localAudioStream);
    }

    // Mixing
    const dest = ac.createMediaStreamDestination();
    if (audioIn_01) audioIn_01.connect(dest);
    if (audioIn_02) audioIn_02.connect(dest);

    // 再加入remote videoTrack
    if (remoteVideoTrack) dest.stream.addTrack(remoteVideoTrack);
    return dest.stream;
  },
  videoOptions: (state) => {
    return state.videoOptions;
  },
  ready: (state) => {
    return state.videoReady;
  },
  display: (state) => {
    return state.videoDisplay;
  },
  screenShareOn: (state) => {
    return state.screenShareOn;
  },
  remoteStream: (state) => {
    return state.remoteStream;
  },
  localStream: (state) => {
    return state.localStream;
  },
  chunksSize: (state) => {
    let sizes = state.chunks.map((c) => {
      return c.size;
    });
    let total = sizes.reduce((a, b) => {
      return a + b;
    }, 0);

    var size = (total / (1024 * 1024)).toFixed(2); // MB
    return size + "MB";
  },
  recorderStatus: (state) => {
    if (state.recorder) {
      return state.recorder.state;
    } else {
      return "";
    }
  },
  // 以 mm:ss 形式回傳目前/最終通話時長
  callDuration: (state) => {
    const ms = state.callDurationMs || 0;
    const d = dayjs.duration(ms);
    const mm = String(d.minutes()).padStart(2, "0");
    const ss = String(d.seconds()).padStart(2, "0");
    return `${mm}:${ss}`;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
